import React from "react";
import BannerCard from "@/components/ui/banner-card";
import KeyFacts from "@/components/pages/country/key-facts";
import Insights from "@/components/pages/country/insights";
import AdditonalResources from "@/components/pages/country/additonal-resources";
import {
  keyFacts,
  climateImpacts,
  stories,
  partners,
  seo,
  jsonLd,
  nepalInsights,
  learnMore,
} from "@/data/nepal";
import ClimateImpacts from "@/components/pages/country/climate-impacts";
import Stories from "@/components/pages/country/stories";
import Partners from "@/components/pages/country/partners";
import States from "@/components/pages/country/states";
import Section from "@/components/ui/section";
import Head from "next/head";
import Seo from "@/utils/seo";
export default function Nepal() {
  return (
    <>
      <Seo seo={seo} />
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd),
          }}
        />
      </Head>
      <BannerCard
        banner={{
          title: "Nepal",
          image: "/images/nepal/nepal banner 1600X400.webp",
        }}
        isActive={true}
        variant="single"
        description="PCII operates two initiatives in Nepal: Migrants Resilience Collaborative and the Climate Resilience Initiative."
      />
      <KeyFacts data={keyFacts} />
      <ClimateImpacts data={climateImpacts} columns={3} />
      <Stories
        data={stories}
        title="Stories of climate-affected internal migrants from Nepal"
      />
      <Partners data={partners} />
      <States
        map="/images/maps/Migration Map_Nepal 2.png"
        title="Geographical Presence of PCI"
      />
      <Section className="bg-[#F4F9FF] -mt-20">
        <h2 className="text-darkBlue text-center mb-12">
          About Internal Migration in Nepal
        </h2>
        <Insights data={nepalInsights} />
      </Section>
      <AdditonalResources data={learnMore} />
    </>
  );
}
